import { ReactComponent as Locked } from '@public/icons/locked.svg';
import Icon from '../atoms/Icon';

const IconLocked = (props) => <Icon as={Locked} {...props} />;

IconLocked.propTypes = Icon.propTypes;

export default IconLocked;
